import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {ContentModel} from '@drl/shared/components/cms-list/models';
import * as moment from 'moment';

@Injectable()
export class ContentAdapterService implements IAdapter<ContentModel> {
  constructor(protected readonly translateSvc: IpsTranslateService) {}

  adaptToModel(resp: any): ContentModel {
    const content: ContentModel = resp;
    if (resp) {
      const date = moment(resp.updated_at).format('Do MMMM YYYY h:mm A');
      content.lastUpdated = `${date}`;
      if (resp.Title) {
        content.title = resp.Title;
      }

      // Prepare criterion string
      content.criteriaString = '';
      if (resp.condition) {
        content.criteriaString = `${this.translateSvc.translate.instant(
          'conditionLbl',
        )}: ${resp.condition.Name}`;
      }
      if (resp.category) {
        content.criteriaString = `${
          content.criteriaString
        } | ${this.translateSvc.translate.instant('categoryLbl')}: ${
          resp.category.Name
        }`;
      }
      if (resp.subcategory1) {
        content.criteriaString = `${
          content.criteriaString
        } | ${this.translateSvc.translate.instant('subCategoriesLbl')}: ${
          resp.subcategory1.Name
        }${resp.subcategory2 ? ', ' + resp.subcategory2.Name : ''}${
          resp.subcategory3 ? ', ' + resp.subcategory3.Name : ''
        }`;
      }
    }
    return content;
  }
  adaptFromModel(data: ContentModel): any {
    return data;
  }
}
